import React, { Component } from 'react';
import '../../includes/custom/css/navigation.css';
import { Link } from 'react-router-dom';
import UserIcon from '../../includes/img/svg/user.svg';
import UsersMenu from '../../includes/img/svg/users-list.svg';
import StoresMenu from '../../includes/img/svg/store.svg';
import PollMenu from '../../includes/img/svg/poll.svg';
import CalendarMenu from '../../includes/img/svg/calendar.svg';
import AnnouncementMenu from '../../includes/img/svg/announcement.svg';
import MobileNotification from '../../includes/img/svg/notification.svg';
import VideoMenu from '../../includes/img/svg/movie-videos.svg';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { ACCESS_RIGHTS, ADMINISTRATOR, SUPER_ADMINISTRATOR, SHAABAA_VIDEO_CREW, MEMBERS_ROUTE, STORES_ROUTE, POLLS_ROUTE, CALENDAR_ROUTE, BANNERANNOUNCEMENT_ROUTE, POPUPANNOUNCEMENT_ROUTE, MOBILENOTIFICATION_ROUTE, VIDEO_ROUTE } from './../../utils/constants';

class SideNavigation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentSelectedGroup: 0
        };
        this.hoverOff = this.hoverOff.bind(this);
        this.hoverOn = this.hoverOn.bind(this);
    }

    hoverOn(selectedGroup) {
        this.setState({
            currentSelectedGroup: selectedGroup
        });
    }

    hoverOff() {
        this.setState({ currentSelectedGroup: 0 });
    }


    render() {

        const currentUser = this.props.isAuthenticated.credentials

        const position = ACCESS_RIGHTS === currentUser.accessRights  ? ADMINISTRATOR : currentUser.accessRights === 3? SHAABAA_VIDEO_CREW : SUPER_ADMINISTRATOR

        return (
            <div className="appSideBar" id='appSideBar'>

                <div className='appSideBarFDiv'>
                    <img className='appProfile' src={UserIcon} alt='adminlogo' />
                    <p className='appProfileName'>{currentUser.firstname} {currentUser.lastname} <br /><span className="adminProfile">{position}</span></p>
                </div>
                <ul className='sideNavItem'>
                    {currentUser.accessRights !== 3 &&
                        <Link className='sideNavAnchor' key={MEMBERS_ROUTE} href={MEMBERS_ROUTE} to={MEMBERS_ROUTE}>
                            <li className='sideNavList' onMouseLeave={this.hoverOff}>
                                <img src={UsersMenu} className="menu-icon" alt="menu-icon"/>
                                Members
                            </li>
                        </Link>
                    }
  
                    {currentUser.accessRights !== 3 &&
                        <Link className='sideNavAnchor' key={STORES_ROUTE} href={STORES_ROUTE} to={STORES_ROUTE}>
                            <li className='sideNavList'>
                                <img src={StoresMenu} className="menu-icon" alt="menu-icon"/>
                                Stores
                            </li>
                        </Link>
                    }

                    {currentUser.accessRights !== 3 &&
                        <Link className='sideNavAnchor' key={POLLS_ROUTE} href={POLLS_ROUTE} to={POLLS_ROUTE}>
                            <li className='sideNavList' onMouseLeave={this.hoverOff}>
                                <img src={PollMenu} className="menu-icon" alt="menu-icon"/>
                                Polls
                            </li>
                        </Link>
                    }

                    {currentUser.accessRights !== 3 &&
                        <Link className='sideNavAnchor' key={CALENDAR_ROUTE} href={CALENDAR_ROUTE} to={CALENDAR_ROUTE}>
                            <li className='sideNavList' onMouseLeave={this.hoverOff}>
                                <img src={CalendarMenu} className="menu-icon" alt="menu-icon"/>
                                Calendar
                            </li>
                        </Link>
                    }

                    {currentUser.accessRights !== 3 &&
                        <Link className='sideNavAnchor' key={BANNERANNOUNCEMENT_ROUTE} href={BANNERANNOUNCEMENT_ROUTE} to={BANNERANNOUNCEMENT_ROUTE}>
                            <li className='sideNavList'>
                                <img src={AnnouncementMenu} className="menu-icon" alt="menu-icon"/>
                                Banner Announcements
                            </li>
                        </Link>
                    }

                    {currentUser.accessRights !== 3 &&
                        <Link className='sideNavAnchor' key={POPUPANNOUNCEMENT_ROUTE} href={POPUPANNOUNCEMENT_ROUTE} to={POPUPANNOUNCEMENT_ROUTE}>
                            <li className='sideNavList'>
                                <img src={AnnouncementMenu} className="menu-icon" alt="menu-icon"/>
                                Popup Announcements
                            </li>
                        </Link>
                    }

                    {currentUser.accessRights !== 3 &&
                        <Link className='sideNavAnchor' key={MOBILENOTIFICATION_ROUTE} href={MOBILENOTIFICATION_ROUTE} to={MOBILENOTIFICATION_ROUTE}>
                            <li className='sideNavList'>
                                <img src={MobileNotification} className="menu-icon" alt="menu-icon"/>
                                Mobile Push Notifications
                            </li>
                        </Link>
                    }
    
                    
                    <Link className='sideNavAnchor' key={VIDEO_ROUTE} href={VIDEO_ROUTE} to={VIDEO_ROUTE}>
                        <li className='sideNavList'>
                            <img src={VideoMenu} className="menu-icon" alt="menu-icon"/>
                            SHAABAA Game Videos
                        </li>
                    </Link>
                </ul>
            </div>

        );
    };

}

const mapStateToProps = (state) => {
    return {
      isAuthenticated: state.auth,
    }
  };


export default withRouter(connect(mapStateToProps)(SideNavigation));